// eslint-disable-next-line no-unused-vars
import React from 'react';
import { func, string } from 'prop-types';
import styled from '@emotion/styled';
import { Button } from '@carbon/react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@emotion/react';

const StickyButtons = styled.div`
  position: sticky;
  top: 90px;
  margin: -19px 0 15px;
  padding-top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 100;
  background-color: #FFF;

  button {
    &:first-of-type {
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }

    &:last-of-type {
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }

    &.active {
      border-color: #041B54;
      background-color: #041B54;
      color: ${ props => props.theme.colors.white };
    }

    height: 40px;
    width: 50%;
    flex-basis: 50%;
    color: #041B54;
    border-color: #041B54;
    background-color: ${ props => props.theme.colors.white };
  }

  @media screen and (max-width: 767px) {
    display: none;
  }
`;

const StyledContainer = styled.div`
  width: 100%;
  margin-bottom: -3px;
  p {
    color: ${ props => props.theme.colors.gray };
    font-size: 0.875rem;
    line-height: 1.125rem;
  }
`;

const FilterButtonContainer = styled.div`
  position: sticky !important;
  top: 150px;
  width: 100%;
  padding: 15px 0;
  background-color: #FFF;
  margin-bottom: 15px;
  z-index: 99;
`;

const StyledFilterButton = styled(Button)`
  width: 100%;
  height: 40px;
  justify-content: center;
  font-size: 1rem;
  color: ${ props => props.theme.colors.white };
`;

const FilterSwitch = ({ onSwitch, onApply, filterType }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isInstant = filterType !== 'multi';
  return (
    <>
      <StickyButtons>
        <Button
          kind={ isInstant ? 'primary' : 'ghost' }
          onClick={ () => onSwitch(true) }
          data-test="onSwitchFilteringType"
          data-testid="instant"
          className={ isInstant ? 'active' : '' }
        >
          { t('filters.instant') }
        </Button>
        <Button
          kind={ !isInstant ? 'primary' : 'ghost' }
          onClick={ () => onSwitch(false) }
          data-test="onSwitchFilteringType"
          data-testid="multi"
          className={ !isInstant ? 'active' : '' }
        >
          { t('filters.multiselect') }
        </Button>
      </StickyButtons>
      { !isInstant && (
        <>
          <StyledContainer theme={ theme }>
            <p>{ t('filters.filterTypeUsage') }</p>
          </StyledContainer>
          <FilterButtonContainer>
            <StyledFilterButton
              kind="primary"
              className="applyFilters red"
              onClick={ onApply }
            >
              { t('filters.filter') }
            </StyledFilterButton>
          </FilterButtonContainer>
        </>
      ) }
    </>
  );
};

FilterSwitch.propTypes = {
  filterType: string,
  onApply: func,
  onSwitch: func
};

export default FilterSwitch;
